



















































































































import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import moment from "moment/moment";
import ErrorMixin from "@/mixins/errorMixins";
import NumberTmpl from "./number.vue";
import jsonURL from "@/shared/urls";

@Component({
  components: {
    NumberTmpl,
  },
})
export default class PrevCalendar extends mixins(MyMixin, ErrorMixin) {
  @Prop() public site!: any;
  @Prop() public prevs!: any;
  public data = new Date();
  public weekInfo: any;
  public dataGetted = false;
  public weekCa = new Array();

  public DATE_FORMAT = "YYYY-MM-DD";

  public mounted() {
    this.init();
  }

  public close() {
    this.$emit("close");
  }

  public init() {
    this.data = moment(this.data).subtract(1, "w").toDate();
    const infos = this.makeMeAWeek(this.data);
    this.weekInfo = {
      num: moment(this.data).format("ww"),
      lib: infos.lib,
      start: moment(infos.start),
      end: moment(infos.end),
      sumW: 0,
      fiabS1: 0,
      prevS1: 0,
    };
    this.transformCa();
  }

  public prev() {
    this.dataGetted = false;
    this.data.setDate(this.data.getDate() - 7);
    const infos = this.makeMeAWeek(this.data);
    this.weekInfo.num = moment(this.data).format("ww");
    this.weekInfo.lib = infos.lib;
    this.weekInfo.start = moment(infos.start).subtract(7, "d");
    this.weekInfo.end = moment(infos.end);
    this.dataGetted = true;
    this.transformCa();
  }

  public next() {
    this.dataGetted = false;
    const today = moment();
    this.data.setDate(this.data.getDate() + 7);
    if (moment(this.data).isSame(today, "w")) {
      this.data = moment(this.data).subtract(1, "w").toDate();
    }
    const infos = this.makeMeAWeek(this.data);
    this.weekInfo.num = moment(this.data).format("ww");
    this.weekInfo.lib = infos.lib;
    this.weekInfo.start = moment(infos.start);
    this.weekInfo.end = moment(infos.end);
    this.dataGetted = true;
    this.transformCa();
  }
  /**
   * reload des chiffres si le calendrier à été ouvert une premiere fois
   */
  @Watch("data", { immediate: true, deep: true })
  public onDateChanged({ value, oldValue }: { value: any; oldValue: any }) {
    if (oldValue !== value) {
      console.log("watch");
      this.init();
    }
  }

  public getWeekCa(date: any) {
    const result = this.weekCa.filter(
      (ca: any) =>
        ca.date.format(this.DATE_FORMAT) === date.format(this.DATE_FORMAT)
    );
    return result[0] ? result[0].value : 0;
  }

  public getRowColor(idex: number) {
    if (idex % 2 === 0) {
      return "background-color : #C5CAE9";
    } else {
      return "background-color :#E8EAF6";
    }
  }

  public getMyPrevision(date: any, type: string) {
    const datestr = date.format(this.DATE_FORMAT);
    // console.log(datestr, this.prevs[datestr])
    if (this.prevs[datestr]) {
      const prev = this.prevs[datestr];
      return prev[type];
    } else {
      return 0;
    }
  }

  public getFiabWeek() {
    return (
      100 -
      Math.abs((this.weekInfo.prevS1 - this.weekInfo.sumW) / this.weekInfo.sumW)
    );
  }

  public getMyFiab(date: any, type: string) {
    const datestr = date.format(this.DATE_FORMAT);
    const prev = this.prevs[datestr];
    return prev[type];
  }

  public calculateFiab(date: any, type: string) {
    const dateBuff = new Date(date);
    if (type === "S1") {
      dateBuff.setDate(dateBuff.getDate() - 7);
    } else {
      dateBuff.setDate(dateBuff.getDate() - 21);
    }
    const ca = this.getWeekCa(moment(date));
    const cacomp = this.getMyPrevision(date, "prev" + type);
    let result = 0;

    result = 100 - Math.abs((cacomp - ca) / ca);

    // console.log(result);
    return result;
  }

  private transformCa() {
    this.weekCa = new Array();
    const config = {
      site: this.site,
      date: moment(this.data).format(this.DATE_FORMAT),
      WS: jsonURL.updateCAHTParJourSurSemaine,
    };
    // console.log("config date transformCa :", config.date);
    this.$store
      .dispatch("home/getGraphData", { config, p: -1 })
      .then((data: any) => {
        // console.log(data);
        // this.ca = data;
        const keys = Object.keys(data);
        for (const ev of keys) {
          const momDate = moment(ev);
          if (momDate.isSameOrBefore(this.weekInfo.end, "d")) {
            const find = this.weekCa.filter((ca: any) =>
              ca.date.isSame(moment(ev))
            );
            if (find.length === 0) {
              this.weekCa.push({
                date: moment(ev),
                value: data[ev],
              });
            }
          }
        }
        console.log(this.weekCa);
        this.weekInfo.prevS1 = 0;
        // this.weekInfo.sumW = 0;
        this.weekInfo.fiabS1 = 0;
        this.weekInfo.sumW = 0;
        this.weekCa.map((day: any) => {
          if (
            (day.date.isBefore(this.weekInfo.end) &&
              day.date.isAfter(this.weekInfo.start)) ||
            day.date.isSame(this.weekInfo.end) ||
            day.date.isSame(this.weekInfo.start)
          ) {
            this.weekInfo.sumW += day.value;
            const mday = day.date.format(this.DATE_FORMAT);
            if (this.prevs[mday]) {
              this.weekInfo.prevS1 += this.prevs[mday].prevS1;
            }
          }
        });
        console.log(this.weekInfo);
      });
    this.dataGetted = true;
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }

  get premierJour(): any {
    return moment(this.data);
  }
}
